module.exports = __webpack_public_path__ + "img/banner.8342cd9a.png";